import React, {useState} from "react";
import {Tabs} from "antd";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {CustomerFluidSubPageLayout} from "components/layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {PackageStatisticsTab} from "./components";
import {useTranslation} from "react-i18next";
import {CustomerStatisticsPageContainer} from "./styles/CustomerStatisticsPage.styles";

const {TabPane} = Tabs;

const CustomerStatisticsPage = () => {
    const {t} = useTranslation(["common"]);
    const [activeTab, setActiveTab] = useState("packageStatistics");

    return (
        <CustomerFluidSubPageLayout>
            <CustomerMenuHeader />
            <CustomerStatisticsPageContainer>
                <Tabs
                    activeKey={activeTab}
                    onChange={setActiveTab}
                    size="large"
                    type="card"
                    style={{minHeight: "600px"}}
                    tabBarStyle={{
                        marginBottom: "24px",
                        borderBottom: "1px solid #f0f0f0"
                    }}
                    className="customer-statistics-tabs"
                >
                    <TabPane tab="Paket İstatistiği" key="packageStatistics">
                        <PackageStatisticsTab />
                    </TabPane>
                </Tabs>
            </CustomerStatisticsPageContainer>
        </CustomerFluidSubPageLayout>
    );
};

export default CustomerStatisticsPage;
